<template>
    <div class="container-main">
        <div class="container-main-header-button">
            <v-btn depressed @click="back">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <span>Редактирование </span>
        </div>
        <v-form ref="formFirst">
            <div class="container-block">
                <div>
                    <v-text-field label="Название" required type="text" outlined :rules="rules"
                        v-model="category.name"></v-text-field>
                </div>
            </div>
        </v-form>




        <div class="container-block" style="width: 100%">
            <div class="container-block-title">
                Прикрепить иконки
            </div>
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">
                                Формат
                            </th>
                            <th class="text-left">
                                Место отображенния
                            </th>
                            <th class="text-left">
                                Иконка
                            </th>
                            <th class="text-left">

                            </th>

                        </tr>
                    </thead>
                    <tbody>



                        <tr style="height: 60px;">
                            <td class="text-left">iOS</td>
                            <td class="text-left">Иконка будет отображаться на телефонах на платформе iOS <br>Прикрепить
                                файл формата pdf </td>
                            <td class="text-left">

                                <v-btn v-if="!newImageIOS" class="button-accept" @click="onButtonClick">
                                    Загрузить pdf
                                </v-btn>
                                <input v-if="!newImageIOS" ref="uploader" class="d-none" type="file"
                                    accept="application/pdf" @change="onFileChanged">

                                <a v-else target="_blank" :href="imgSrcIOS">
                                    <span v-if="newImageIOS.name">{{ newImageIOS.name }}</span>
                                    <span v-else>Иконка</span>
                                </a>
                            </td>

                            <td class="text-left">
                                <v-btn icon @click="deleteImageIOS">
                                    <v-icon color="var(--app-red-1)">
                                        mdi-delete-outline
                                    </v-icon>
                                </v-btn>

                            </td>
                        </tr>
                        <tr style="height: 60px;">
                            <td class="text-left">Android</td>
                            <td class="text-left">Иконка будет отображаться на телефонах на платформе Android <br>
                                Прикрепить файл формата svg</td>
                            <td class="text-left">
                                <v-btn v-if="!newImageAND" class="button-accept" @click="onButtonClickAND">
                                    Загрузить svg
                                </v-btn>
                                <input v-if="!newImageAND" ref="uploaderAND" class="d-none" type="file" accept="image"
                                    @change="onFileChangedAND">
                                <img style=" max-width: 50px; max-height: 50px;" v-else :src="imgSrcAND">
                            </td>

                            <td class="text-left">
                                <v-btn icon @click="deleteImageAND">
                                    <v-icon color="var(--app-red-1)">
                                        mdi-delete-outline
                                    </v-icon>
                                </v-btn>

                            </td>
                        </tr>



                    </tbody>
                </template>
            </v-simple-table>

            <v-alert color="var(--app-red-1)" type="error" v-model="errImages">
                Загрузите все изображения


            </v-alert>
            <v-divider></v-divider>




        </div>


        <div class="container-block-footer-buttons">
            <div>
                <v-btn @click="saveCategory" style="width: auto !important" class="button-accept">
                    Сохранить
                </v-btn>

            </div>
            <div>
                <v-btn outlined @click="openDialogDelete" style="width: auto !important" color="var(--app-red-1)"
                    class="button-accept-outlined">
                    Удалить
                </v-btn>
            </div>
        </div>

        <v-dialog width="600px" height="auto" persistent v-model="dialogDelete">
            <v-card>
                <v-card-title class="dialog-title">
                    <span class="title">Точно хотите удалить баннер?</span>
                    <v-icon @click="dialogDelete = false;">mdi-close</v-icon>
                </v-card-title>
                <v-card-actions class="dialog-buttons">
                    <v-btn @click="dialogDelete = false;" style="width: 120px" outlined color="var(--app-green-1)">
                        Нет
                    </v-btn>
                    <v-btn @click="deleteBanner" style="width: 120px" outlined color="var(--app-red-1)">
                        Да
                    </v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>


    </div>
</template>
<script>



export default {

    data: () => ({


        dialogDelete: false,

        errImages: false,

        category: {},

        rules: [value => !!value || 'Обязательно к заполнению'],

        newImageIOS: null,
        imgSrcIOS: '',

        newImageAND: null,
        imgSrcAND: '',


    }),


    methods: {
        back() {
            this.$router.push({ name: 'Categories' })
        },
        onButtonClick() {
            this.$refs.uploader.click()
        },
        onButtonClickAND() {
            this.$refs.uploaderAND.click()
        },

        onFileChanged(e) {
            this.errImages = false
            this.newImageIOS = e.target.files[0]
            this.imgSrcIOS = URL.createObjectURL(this.newImageIOS)

        },
        onFileChangedAND(e) {
            this.errImages = false
            this.newImageAND = e.target.files[0]
            this.imgSrcAND = URL.createObjectURL(this.newImageAND)
        },
        openDialogDelete() {
            this.dialogDelete = true
        },
        deleteBanner() {
            this.$axios.delete(this.$store.getters.apiAdminPanelV2 + '/category', {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                },
                params: {
                    categoryId: this.$route.params.id
                }
            })
                .then(() => {
                    this.$router.push({ name: 'Categories' })
                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })
        },

        deleteImageIOS() {
            this.newImageIOS = null
            this.imgSrcIOS = ''

        },
        deleteImageAND() {
            this.newImageAND = null
            this.imgSrcAND = ''
        },

        getCategory() {
            this.$axios.get(this.$store.getters.apiAdminPanelV2 + '/category', {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                },
                params: {
                    categoryId: this.$route.params.id
                }
            })
                .then(res => {

                    this.category = res.data
                    this.newImageIOS = this.category.iosIcon
                    this.newImageAND = this.category.androidIcon
                    this.imgSrcIOS = this.category.iosIcon
                    this.imgSrcAND = this.category.androidIcon

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },

        saveCategory() {
            if (this.$refs.formFirst.validate()) {
                if (this.newImageIOS && this.newImageAND) {
                    let formData = new FormData();

                    formData.append('categoryId', this.category.id)
                    formData.append('name', this.category.name)
                    formData.append('iosIcon', this.newImageIOS)
                    formData.append('androidIcon', this.newImageAND)


                    this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/category', formData, {
                        headers: {
                            'authorization': this.$store.getters.adminPanelHeaderAuth
                        }
                    })
                        .then(() => {
                            this.$router.push({ name: 'Categories' })


                        })
                        .catch(err => {
                            this.$store.commit('errorSet', true)
                            this.$store.commit('errorTextSet', err)
                        })

                }
                else {
                    this.errImages = true
                }

            }


        }


    },
    created() {
        this.getCategory()

    },

    watch: {
    }
}
</script>
<style lang="scss" scoped>
.container-main {
    box-sizing: border-box;

    padding: 40px !important;

    .container-main-header-button {
        display: flex;
        align-items: center;
        margin-bottom: 30px;

        span {
            font-size: 28px;
            font-weight: 400;
            margin-left: 16px;
        }
    }

    .container-block {
        width: 50%;
        margin-bottom: 20px;

        .container-block-title {
            font-size: 24px;
            font-weight: 600;
            margin-bottom: 16px;

        }

        .container-block-gallery-button {
            text-decoration: underline;
            color: #1064DD;
            font-size: 18px;
            font-weight: 400;
            cursor: pointer;
            padding-bottom: 20px;
        }

        .table-img {

            height: 38px;
            object-fit: contain;
        }

        .container-main-checkbox {
            border: 1px solid rgba(0, 0, 0, 0.42);
            border-radius: 4px;
            padding-top: 20px;
            padding-left: 12px;
            margin-top: 0px !important;

        }
    }

    .container-block-footer-buttons {
        display: flex;
        justify-content: space-between;
        width: 50%;
        margin-top: 60px;
    }

}

.dialog-tablet-img {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;

    img {
        width: 658;
        height: 192;
    }
}
</style>